module.exports = __webpack_public_path__ + "img/errorMessageIE.fa85aae7.jpg";